import React, { useEffect, useState } from "react";
import { Activity, Download, ShieldCheck } from "lucide-react";

const API_BASE = "/api/android-updates/email/download/";

export function AndroidEmailDownload() {
  const [token] = useState(() => {
    const params = new URLSearchParams(window.location.search);
    const value = params.get("token") || "";

    // Rimuove il token dall'URL visibile e dalla cronologia corrente.
    window.history.replaceState(
      window.history.state,
      "",
      window.location.pathname
    );

    return value;
  });

  const [release, setRelease] = useState(null);
  const [loading, setLoading] = useState(true);
  const [downloading, setDownloading] = useState(false);
  const [error, setError] = useState("");
  const [completed, setCompleted] = useState(false);

  const validToken = /^[A-Za-z0-9_-]{43}$/.test(token);

  useEffect(() => {
    if (!validToken) {
      setError("Collegamento non valido.");
      setLoading(false);
      return;
    }

    let cancelled = false;

    fetch(API_BASE + encodeURIComponent(token), {
      method: "GET",
      cache: "no-store",
      credentials: "omit"
    })
      .then(async response => {
        if (!response.ok) {
          throw new Error("Il collegamento è scaduto, già utilizzato o non è più disponibile.");
        }
        return response.json();
      })
      .then(data => {
        if (!cancelled) setRelease(data);
      })
      .catch(err => {
        if (!cancelled) setError(err.message);
      })
      .finally(() => {
        if (!cancelled) setLoading(false);
      });

    return () => {
      cancelled = true;
    };
  }, [token, validToken]);

  const download = () => {
    if (downloading || !release || completed) return;

    setError("");
    setDownloading(true);

    // Il form HTML gestisce il trasferimento direttamente nel browser.
    // Il token viene consumato dal backend alla richiesta di download.
    const form = document.createElement("form");
    form.method = "POST";
    form.action = "/api/android-updates/email/download-form";
    // Mantiene visibile la pagina anche in caso di errore HTTP.
    form.target = "android-apk-download-frame";
    form.style.display = "none";

    const input = document.createElement("input");
    input.type = "hidden";
    input.name = "token";
    input.value = token;

    form.appendChild(input);

    let frame = document.getElementById("android-apk-download-frame");

    if (!frame) {
      frame = document.createElement("iframe");
      frame.id = "android-apk-download-frame";
      frame.name = "android-apk-download-frame";
      frame.title = "Download APK 118Finder";
      frame.style.display = "none";
      document.body.appendChild(frame);
    }

    document.body.appendChild(form);
    form.submit();
    form.remove();

    // L'invio del form non conferma il completamento del download.
    // Il pulsante resta disabilitato per evitare richieste duplicate.
    setCompleted(true);
    setDownloading(false);
  };

  return (
    <main className="login-shell">
      <section className="login-panel">

        <div className="brand-mark">
          <Activity size={25} />
          <span>CENTRALE <b>118</b></span>
        </div>

        <div className="login-copy">
          <span className="eyebrow">118FINDER / ANDROID</span>
          <h1>Download applicazione</h1>
          <p>
            Scarica la versione autorizzata dell'app Android 118Finder
            tramite il collegamento temporaneo ricevuto via email.
          </p>
        </div>

        <div className="login-form">

          {loading && (
            <p role="status">Verifica del collegamento in corso...</p>
          )}

          {!loading && release && !completed && (
            <>
              <div className="success">
                <strong>Versione {release.version_name}</strong>
                <p>Codice versione: {release.version_code}</p>
                <p>
                  Collegamento valido fino al{" "}
                  {new Date(release.expires_at).toLocaleString("it-IT")}
                </p>
              </div>

              <p>
                Il collegamento consente un solo download.
                Dopo l'utilizzo non sarà più disponibile.
              </p>

              <button
                type="button"
                className="primary-btn"
                disabled={downloading}
                onClick={download}
              >
                <Download size={18} />
                {downloading ? "Download in corso..." : "Scarica APK"}
              </button>
            </>
          )}

          {completed && (
            <div className="success" role="status">
              Richiesta di download inviata al browser.
              Se il trasferimento non è riuscito, il collegamento
              potrebbe essere già stato utilizzato.
            </div>
          )}

          {error && (
            <p role="alert" style={{ color: "var(--danger, #b42318)" }}>
              {error}
            </p>
          )}

          <a className="primary-btn" href="/">
            Torna al sito
          </a>

        </div>
      </section>

      <aside className="login-aside">
        <div className="signal-grid">
          <div>
            <span>01</span>
            <b>VERSIONE UFFICIALE</b>
            <small>APK Production pubblicato su 118Finder</small>
          </div>

          <div>
            <span>02</span>
            <b>COLLEGAMENTO TEMPORANEO</b>
            <small>Validità massima di 15 minuti</small>
          </div>

          <div>
            <span>03</span>
            <b>DOWNLOAD PROTETTO</b>
            <small>Collegamento utilizzabile una sola volta</small>
          </div>
        </div>

        <div className="aside-foot">
          <span>
            <ShieldCheck size={15} /> DOWNLOAD PROTETTO
          </span>
          <span>118 OPS</span>
        </div>
      </aside>
    </main>
  );
}
